/**=========================================================
 * Module: app-list.js
 * Handles list
 =========================================================*/

App.directive('appList', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/list.html',
      restrict: 'E',
      replace: true,
      scope: { 
          list: '=list'
        }
  };

});
